import React, { type KeyboardEvent, type MouseEvent, useCallback } from 'react';
import { itamSettingsRoute } from '@jira/router-routes__itam-routes/src/itamSettingsRoute.tsx';
import type { MoreNavMenuButtonMenuItemsProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/submenu/index.tsx';
import Section from '@atlaskit/menu/section';
import ButtonItem from '@atlaskit/menu/button-item';

import SettingsIcon from '@atlaskit/icon/core/settings';
import { defineMessage, useIntl } from '@atlassian/jira-intl';
import { useRouterActions } from '@atlassian/react-resource-router';

const PRACTICE_HAM = 'ham';
const MENU_ITEM_HARDWARE = 'hardware';

const hardwareSettingsLabel = defineMessage({
	id: 'itam.nav4-menu-item.hardware-settings',
	defaultMessage: 'Hardware settings',
	description: 'Label for the Hardware settings option in the Hardware menu item flyout.',
});

export const HardwareSettingsMenuItems = ({
	onClose,
}: MoreNavMenuButtonMenuItemsProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { pushTo } = useRouterActions();

	const handleSettingsClick = useCallback(
		(event: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => {
			pushTo(itamSettingsRoute, {
				params: {
					practice: PRACTICE_HAM,
					menu_item: MENU_ITEM_HARDWARE,
				},
			});
			onClose?.(event);
		},
		[pushTo, onClose],
	);

	return (
		<Section isList>
			<ButtonItem
				onClick={handleSettingsClick}
				iconBefore={<SettingsIcon label="" color="currentColor" />}
			>
				{formatMessage(hardwareSettingsLabel)}
			</ButtonItem>
		</Section>
	);
};
